export const pluralise = (
  items: any[] | undefined,
  singular: string,
  plural?: string,
): string => {
  const irregulars: Record<string, string> = {
    is: "are",
    has: "have",
    does: "do",
    this: "these",
    that: "those",
    it: "they",
    was: "were",
  };

  if (items?.length === 1) return singular;
  if (plural) return plural;

  const lowerSingular = singular.toLowerCase();
  if (irregulars[lowerSingular]) {
    const isCapitalised = singular[0] === singular[0].toUpperCase();
    const pluralForm = irregulars[lowerSingular];
    return isCapitalised
      ? pluralForm.charAt(0).toUpperCase() + pluralForm.slice(1)
      : pluralForm;
  }

  return `${singular}s`;
};
